module.exports = __webpack_public_path__ + "img/Icon-tree-user-vitamins-1.a2255990.svg";